"use client"

import { MoveDownRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MoveDownRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MoveDownRightIcon = component(Icon)({ as: MoveDownRight })
